import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const StudioInformationSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./StudioInformationSubForm"))
);
